


































import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";

import {
    pageData
} from "@/store/pageData";
import CarrerTitle from '../components/CarrerTitle.vue';
import DoubleImgBlock from '../components/DoubleImgBlock.vue';
import JobList from '../components/JobList.vue';
import {
    TimelineMax,
    TweenLite,
    TweenMax,
    Power2,
    Power1,
    Power3
} from "gsap";
@Component({
    name: "Career",
    components: {
        title_subtitle_block: CarrerTitle,
        double_image_block: DoubleImgBlock,
        job_list: JobList
    }
})
export default class Career extends Vue {
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    public HOST: string = HOST;
    public heroimganim(): void {
        const {
            imgoverlay
        } = this.$refs
        TweenLite.delayedCall(1.5, overlay);

        function overlay() {
            TweenMax.to(imgoverlay, .03, {
                opacity: .4,
                ease: Power2.easeOut
            });
        }
        var heroimganim = new TimelineMax({});
        heroimganim
            .to(imgoverlay, .01, {
                opacity: 0,
            })

            .staggerFrom(".banner-wrap img", 1.1, {
                delay: .2,
                autoAlpha: 0,
                scale: 2,
                height: '10%',
                yPercent: 10,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.1)
            .to('.banner-text', .01, {
                overflow: 'hidden'
            })
            .staggerFrom('.banner-text h1', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .1, '-=.05')
            .staggerFrom('.banner-text p', .6, {
                autoAlpha: 0,
                y: 80,
                ease: Power1.easeOut,
                clearProps: 'all'
            }, .2, '-=.3')
            .to('.banner-text', .01, {
                clearProps: 'all'
            });

    }

    public mounted() {
        this.heroimganim();
    }
}
